import { PASTRY_COLORS } from "./constants";

export const getRandomColor = () => {
  const randomIndex = Math.floor(Math.random() * PASTRY_COLORS.length);
  return PASTRY_COLORS[randomIndex];
};
export const getColorForIndex = (index) => {
  return PASTRY_COLORS[index % PASTRY_COLORS.length];
};
export function thumbnailView(imageUrl) {
  //   c_scale ==> crop scale
  //   g_auto ==> gravity auto
  //   f_auto ==> format auto
  //   q_auto ==> quality auto
  const resizedUrl = `${imageUrl?.replace(
    "/upload/",
    `/upload/c_scale,g_auto,q_auto,f_auto/e_improve:indoor:100/`
  )}`;
  return resizedUrl;
}

export const slugToTitle = (slug) => {
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
export const listAllWeight = (products) => {
  let weights = [];
  products.forEach((element) => {
    element.weight_ids.forEach((f) => {
      weights.push({
        weight_id: f.id,
        unit_name: element?.unit?.unit_name,
        weight_name: f.itemName,
      });
    });
  });
  weights = removeDuplicates(weights, (it) => it.weight_id);

  weights.sort(function (a, b) {
    const nameA = +a.weight_name; // ignore upper and lowercase
    const nameB = +b.weight_name; // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  });
  return weights;
};
export const listAllFlavour = (products) => {
  let flavours = [];
  products.forEach((element) => {
    element.flavour.forEach((f) => {
      if (f.itemName !== "Default") {
        flavours.push({ flavour_id: f.id, flavour_name: f.itemName });
      }
    });
  });

  flavours = removeDuplicates(flavours, (it) => it.flavour_id);
  flavours?.sort(function (a, b) {
    const nameA = a.flavour_name.toUpperCase(); // ignore upper and lowercase
    const nameB = b.flavour_name.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  });
  return flavours;
};

const removeDuplicates = (data, key) => {
  return [...new Map(data?.map((x) => [key(x), x])).values()];
};

export const maxLength = 40;

export const formatTime = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0"
  )}`;
};

export function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

export const statusColors = (orderItem) => {
  let response = {
    color: "",
    backgroundColor: "",
  };

  switch (orderItem?.preview_status) {
    case "Submitted":
      response = {
        backgroundColor: "#FEEBEA",
        color: "#C51605",
      };
      break;
    case "Confirmed":
      response = {
        backgroundColor: "#FFF6ED",
        color: "#ff7b00",
      };
      break;
    case "Order Preparing":
      response = {
        backgroundColor: "#FFFCED",
        color: "#FFD700",
      };
      break;
    case "Cake Ready":
      response = {
        backgroundColor: "#F7FDEC",
        color: "#80b918",
      };
      break;
    case "Out For Delivery":
      response = {
        backgroundColor: "#F7FDEC",
        color: "#80b918",
      };
      break;
    case "Delivered":
      response = {
        backgroundColor: "#E4FFE4",
        color: "green",
      };
      break;
    case "Cancelled":
      response = {
        backgroundColor: "white",
        color: "red",
      };
      break;

    default:
      response = {
        backgroundColor: "#C51605",
        color: "red",
      };
  }

  return response;
};
export function formatDate(inputDate) {
  if (!inputDate) {
    return "Invalid Date";
  }

  const dateParts = inputDate.split("-");
  if (dateParts.length !== 3) {
    return "Invalid Date Format";
  }

  const year = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10) - 1; // Months are 0-indexed
  const day = parseInt(dateParts[2], 10);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const formattedDate = `${day}-${monthNames[month]}-${year}`;
  return formattedDate;
}

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const scrollToElement = () => {
  window.scrollTo({
    top: document.documentElement.scrollHeight,
    behavior: "smooth",
  });
};
